import React from "react";
import { useSelector } from "react-redux";
import { LoginContainer } from "../../login/components";
import BookListContainer from "../../book/bookList/components/BookListContainer";

const RouteHome = () => {
  // redux state + localStorage 둘 다 체크 → 로그인 성공 즉시 BookList로 전환되고,
  // 새로고침/재방문 시엔 localStorage 폴백.
  const loginInfo = useSelector(({ loginReducer }) => loginReducer.loginInfo);
  const isLoggedIn = !!(loginInfo && loginInfo.token) || !!window.localStorage.getItem("token");

  if (isLoggedIn) {
    return <BookListContainer />;
  }
  return <LoginContainer />;
};

export default RouteHome;
